import React from "react"
import styled from "@emotion/styled"

const Humberger = props => {
  return (
    <StyledHuberger isOpen={props.isOpen} size={props.size}>
      <div></div>
      <div></div>
    </StyledHuberger>
  )
}

const StyledHuberger = styled.div`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  > div {
    width: 100%;
    height: 1px;
    background-color: #232323;

    transition: transform 0.7s ease-in-out;

    &:first-child {
      transform: rotate(${props => (props.isOpen ? "45deg" : "0")})
        scale(${props => (props.isOpen ? "0.73" : "1")});
      transform-origin: top left;
    }

    &:last-child {
      transform-origin: bottom left;
      transform: rotate(${props => (props.isOpen ? "-45deg" : "0")})
        scale(${props => (props.isOpen ? "0.73" : "1")});
    }
  }
`

export default Humberger
